AuthRoute = require 'mixins/authenticated-route'

App.DeliveryZonesRestaurantZoneRoute = Em.Route.extend AuthRoute,
  model: (params) ->
    @store.find 'delivery-zone', params.zone_id

  setupController: (controller, model) ->
    @_super(arguments...)
    @controllerFor('delivery.zones').set('selectedZone', model)

  deactivate: ->
    @controllerFor('delivery.zones').set('selectedZone', null)